export const detectBrowser = (): string => {
  if (navigator.userAgent.match('Opera') || navigator.userAgent.match('OPR')) {
    return 'Opera';
  }
  if (navigator.userAgent.match('Chrome')) {
    return 'Chrome';
  }
  if (navigator.userAgent.match('Safari')) {
    return 'Safari';
  }
  if (navigator.userAgent.match('Firefox')) {
    return 'Firefox';
  }
  if (navigator.userAgent.match('MSIE')) {
    return 'IE';
  }

  return 'Unknown';
};
